import './styles/ListingItem.scss';

import { Grid, Paper, Icon } from '@mui/material';

import clsx from 'clsx';
import parse from 'html-react-parser';
import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import trunc from 'trunc-html';

import CustomCarousel from 'app/components/Carousel';
import Belongings from 'assets/belongings.svg';
import BulletinBoard from 'assets/bulletin-board.svg';
import Flat from 'assets/flat.svg';
import Study from 'assets/materials.svg';
import { translations } from 'locales/i18n';

interface Props {
  listing: any;
  noOpen?: boolean;
  isOwnListing?: boolean;
  preview?: boolean;
}

const DESCRIPTION_CHAR_LIMIT = 120;

export const ListingItem: FunctionComponent<Props> = ({
  listing,
  noOpen,
  isOwnListing,
  preview
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const getTypeIcon = () => {
    switch (listing.type) {
      case 'study':
        return <img className="listing__body__type-icon" src={Study} alt="study icon" />;
      case 'flat':
        return <img className="listing__body__type-icon" src={Flat} alt="flat rent icon" />;
      case 'belongings':
      default:
        return <img className="listing__body__type-icon" src={Belongings} alt="belongings icon" />;
    }
  };

  return (
    <Grid item xs={12} md={6} className={clsx('listing', { 'listing--own': isOwnListing })}>
      <Grid component={Paper} className={clsx('listing__body', {})} elevation={3}>
        <Grid container>
          <Grid
            item
            xs={12}
            md={6}
            lg={3}
            style={{ alignSelf: 'center', textAlign: 'center' }}
            className="listing__body__preview"
          >
            {preview || !listing.photos ? (
              <img src={BulletinBoard} alt="" style={{ width: '5em' }} />
            ) : (
              <CustomCarousel path="bulletin-board/files" images={listing.photos} />
            )}
          </Grid>
          <Grid item xs onClick={() => !noOpen && navigate(`/bulletin/${listing.id}`)}>
            <Grid container>
              <Grid item xs>
                <Grid container className="listing__body__type">
                  {t(translations.pages.listings.type[listing.type]())}
                </Grid>
                <Grid container className="listing__body__title">
                  {listing.title}
                </Grid>
              </Grid>
              <Grid item xs="auto">
                <Grid container>
                  {isOwnListing && (
                    <Icon
                      className="fas fa-crown listing__body__own-marker"
                      style={{ width: 'auto' }}
                    />
                  )}
                  {getTypeIcon()}
                </Grid>
              </Grid>
            </Grid>
            <Grid container className="listing__body__description">
              {parse(trunc(listing.offerText, DESCRIPTION_CHAR_LIMIT).html)}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};
